import { useSyncExternalStore } from 'react';

/**
 * After sign-in, /start keeps its storyboard view over the home screen while the home screen starts the video. The
 * home screen lets go of it when it will not start one by itself (no draft, another tab took it, the 20-second wait
 * ran out, an error, the key dialog), so the person sees what it has to say.
 */
let released = false;
const listeners = new Set<() => void>();

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export function releaseCover(): void {
  if (released) return;
  released = true;
  listeners.forEach((l) => l());
}

export function holdCover(): void {
  released = false;
  listeners.forEach((l) => l());
}

export const useCoverReleased = (): boolean => useSyncExternalStore(subscribe, () => released);
